import React from 'react';
import {Outlet} from "react-router-dom";

type HomeProps = {
  children?: React.ReactNode | null
}


function Home(props: HomeProps) {

  return (
      <Outlet/>
  );
}

export default Home;